import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'

Vue.use(Router)

export default new Router({
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            redirect: 'hex-to-bytes',
            component: DashboardLayout,
            children: [
                {
                    path: '/hex-to-bytes',
                    name: 'Hex to Bytes Array',
                    component: () => import('./views/HexToBytes.vue')
                },
                {
                    path: '/dec-to-hex',
                    name: 'Dec to Hex Value',
                    component: () => import('./views/DecHex.vue')
                },
                {
                    path: '/hex-to-dec',
                    name: 'Hex to Dec Value',
                    component: () => import('./views/HexToDec.vue')
                },
                {
                    path: '/sha224',
                    name: 'SHA224 Hash',
                    component: () => import('./views/Sha224.vue')
                },
                {
                    path: '/sha256',
                    name: 'SHA256 Hash',
                    component: () => import('./views/Sha256.vue')
                },
                {
                    path: '/sha384',
                    name: 'SHA384 Hash',
                    component: () => import('./views/Sha384.vue')
                },
                {
                    path: '/sha512',
                    name: 'SHA512 Hash',
                    component: () => import('./views/Sha512.vue')
                },
                {
                    path: '/md5',
                    name: 'MD5 Hash',
                    component: () => import('./views/Md5.vue')
                },
                {
                    path: '/sha3',
                    name: 'SHA3 Hash',
                    component: () => import('./views/Sha3.vue')
                },
                {
                    path: '/sha1',
                    name: 'SHA1 Hash',
                    component: () => import('./views/Sha1.vue')
                },
                {
                    path: '/dec-to-oct',
                    name: 'Dec to Oct',
                    component: () => import('./views/DecToOct.vue')
                },
                {
                    path: '/dec-to-bin',
                    name: 'Dec to Bin',
                    component: () => import('./views/DecToBin.vue')
                },
                {
                    path: '/bin-to-dec',
                    name: 'Bin to Dec',
                    component: () => import('./views/BinToDec.vue')
                },
                {
                    path: '/ripemd160',
                    name: 'RIPEMD160 Hash',
                    component: () => import('./views/RipeMd160.vue')
                },
                {
                    path: '/to-base64',
                    name: 'To Base64',
                    component: () => import('./views/Base64.vue')
                },
                {
                    path: '/from-base64',
                    name: 'From Base64',
                    component: () => import('./views/FromBase64.vue')
                },
                {
                    path: '/bytes-to-hex',
                    name: 'Bytes To Hex',
                    component: () => import('./views/BytesToHex.vue')
                },
                {
                    path: '/text-to-base58',
                    name: 'Text To Base58',
                    component: () => import('./views/ToBase58.vue')
                },
                {
                    path: '/base58-decoder',
                    name: 'Base58 Decoder',
                    component: () => import('./views/FromBase58.vue')
                },
                {
                    path: '/aes-encoder',
                    name: 'AES Encoder',
                    component: () => import('./views/AesEnc.vue')
                },
                {
                    path: '/aes-decoder',
                    name: 'AES Decoder',
                    component: () => import('./views/AesDecode.vue')
                },
                {
                    path: '/rabbit-encoder',
                    name: 'Rabbit Encoder',
                    component: () => import('./views/RabbitEncode.vue')
                },
                {
                    path: '/rabbit-decoder',
                    name: 'Rabbit Decoder',
                    component: () => import('./views/RabbitDecode.vue')
                },
                {
                    path: '/rc4-encrypt',
                    name: 'RC4 Encrypt',
                    component: () => import('./views/Rc4Encrypt.vue')
                },
                {
                    path: '/rc4-decrypt',
                    name: 'RC4 Decrypt',
                    component: () => import('./views/Rc4Decrypt.vue')
                },
                {
                    path: '/des-encrypt',
                    name: 'DES Encrypt',
                    component: () => import('./views/DesEncrypt.vue')
                },
                {
                    path: '/des-decrypt',
                    name: 'DES Decrypt',
                    component: () => import('./views/DesDecrypt.vue')
                },
                {
                    path: '/3des-encrypt',
                    name: '3DES Encrypt',
                    component: () => import('./views/3DesEncrypt.vue')
                },
                {
                    path: '/3des-decrypt',
                    name: '3DES Decrypt',
                    component: () => import('./views/3DesDecrypt.vue')
                },
                {
                    path: '/crc32',
                    name: 'CRC32',
                    component: () => import('./views/Crc32.vue')
                },
                {
                    path: '/sha256-file',
                    name: 'File SHA256',
                    component: () => import('./views/Sha256File.vue')
                },
            ]
        },
    ]
})
